import { ResponseInterceptor } from 'react-fetching-library';
import store from '../../store';
import { clearAuth } from '../../store/authSlice';
import { toast } from 'react-toastify';
import { AuthUtils } from '../../utils/auth';

export const responseInterceptor: () => ResponseInterceptor = () => () => async (action: any, response: any) => {
    console.log('[Response Interceptor] Status:', response.status, 'Endpoint:', action.endpoint);
    
    // Handle HTTP error responses
    if (response.status >= 400) {
        console.error(`[Response Interceptor] API Error ${response.status}:`, response);

        // Handle authentication errors
        if (response.status === 401) {
            console.log('[Response Interceptor] 401 - Clearing auth (NO REDIRECT)');
            
            // Clear authentication using AuthUtils
            AuthUtils.clearAuth();
            
            // Clear Redux state
            store.dispatch(clearAuth());

            // Show error message
            toast.error('Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại!');

            // DON'T redirect - let the component handle re-rendering
            // This prevents page reload and allows modal-based login

            return {
                ...response,
                error: true,
                errorObject: new Error('Authentication required. Please login again.')
            };
        }

        // Handle other client errors (4xx)
        if (response.status >= 400 && response.status < 500) {
            let errorMessage = 'Có lỗi xảy ra. Vui lòng thử lại!';

            // Try to get error message from response
            if (response.payload && response.payload.message) {
                errorMessage = response.payload.message;
            } else if (response.errorObject && response.errorObject.message) {
                errorMessage = response.errorObject.message;
            }

            // Handle array of messages - show each as separate toast
            if (Array.isArray(errorMessage)) {
                errorMessage.forEach((message: string) => {
                    toast.error(message);
                });
            } else {
                toast.error(errorMessage);
            }
        }

        // Handle server errors (5xx)
        if (response.status >= 500) {
            toast.error('Lỗi máy chủ. Vui lòng thử lại sau!');

            return {
                ...response,
                error: true,
                errorObject: new Error('Server error. Please try again later.')
            };
        }
    }

    return response;
};

